import { FormGroup } from "@blueprintjs/core";
import { DateRangeInput } from "@blueprintjs/datetime";
import { ItemGridFilter, type ItemGridFilterProps } from "./ItemGridFilter";

type ItemGridFilterDateRangeProps = Omit<
  ItemGridFilterProps,
  "onClickFilterReset" | "children"
> & {
  start?: Date;
  end?: Date;
  onRequestFilterReset: () => void;
  onRequestFilterUpdate: (start: Date | null, end: Date | null) => void;
};

export function ItemGridFilterDateRange({
  start,
  end,
  property,
  text,
  onRequestFilterReset,
  onRequestFilterUpdate,
}: ItemGridFilterDateRangeProps) {
  return (
    <ItemGridFilter
      property={property}
      onClickFilterReset={() => onRequestFilterReset()}
      text={text}
    >
      <FormGroup helperText="Inclusive date range filter">
        <DateRangeInput
          allowSingleDayRange
          className="item-grid-filter-date-range"
          closeOnSelection
          contiguousCalendarMonths
          dateFnsFormat="yyyy-MM-dd HH:mm:ss"
          fill
          highlightCurrentDay
          onChange={(range) =>
            onRequestFilterUpdate(range[0] ?? null, range[1] ?? null)
          }
          selectAllOnFocus
          shortcuts
          timePrecision="second"
          value={[start ?? null, end ?? null]}
        />
      </FormGroup>
    </ItemGridFilter>
  );
}
